import * as tslib_1 from "tslib";
import store from '../store/store';
import { SuggestionKind } from 'owa-search-service';
export default function queryIncludesKQLSuggestion() {
    /**
     * Determine whether there are any segments or people pills in the store.
     */
    return ((store.suggestionSegments && store.suggestionSegments.length > 0) ||
        (store.suggestionPills &&
            tslib_1.__spread(store.suggestionPills.values()).filter(function (pill) { return pill.kind == SuggestionKind.People; })
                .length > 0));
}
//# sourceMappingURL=queryIncludesKQLSuggestion.js.map